import * as Yup from 'yup';
import { formikRequired } from '../../../../../Admin/SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    reason: formikRequired,
  });

export default Validator;
